/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Exclusive_TreeInputs */

const en_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exclusive Trees`)
};

const ar_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاشجار الحصرية لـ بلس`)
};

const de_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exklusive Bäume`)
};

const es_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles exclusivos Plus`)
};

const fr_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres exclusifs Plus`)
};

const it_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi Plus esclusivi`)
};

const ja_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の木`)
};

const ko_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 전용 나무`)
};

const pt_br_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores exclusivas Plus`)
};

const ru_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивные растения Plus`)
};

const th_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้สุดพิเศษเฉพาะ Plus`)
};

const tr_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Özel Ağaçlar`)
};

const zh_cn_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 独享树种`)
};

const zh_tw_plus_exclusive_tree = /** @type {(inputs: Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 獨享樹種`)
};

/**
* | output |
* | --- |
* | "Plus Exclusive Trees" |
*
* @param {Plus_Exclusive_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_exclusive_tree = /** @type {((inputs?: Plus_Exclusive_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Exclusive_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_exclusive_tree(inputs)
	if (locale === "ar") return ar_plus_exclusive_tree(inputs)
	if (locale === "de") return de_plus_exclusive_tree(inputs)
	if (locale === "es") return es_plus_exclusive_tree(inputs)
	if (locale === "fr") return fr_plus_exclusive_tree(inputs)
	if (locale === "it") return it_plus_exclusive_tree(inputs)
	if (locale === "ja") return ja_plus_exclusive_tree(inputs)
	if (locale === "ko") return ko_plus_exclusive_tree(inputs)
	if (locale === "pt_br") return pt_br_plus_exclusive_tree(inputs)
	if (locale === "ru") return ru_plus_exclusive_tree(inputs)
	if (locale === "th") return th_plus_exclusive_tree(inputs)
	if (locale === "tr") return tr_plus_exclusive_tree(inputs)
	if (locale === "zh_cn") return zh_cn_plus_exclusive_tree(inputs)
	return zh_tw_plus_exclusive_tree(inputs)
});